import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './style.css';

export const DateTimePicker = (props: any) => <DatePicker {...props}/>